import { render, staticRenderFns } from "./OrganismTheHeader.vue?vue&type=template&id=c50a921a"
import script from "./OrganismTheHeader.vue?vue&type=script&lang=js"
export * from "./OrganismTheHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports